(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-poison-menu-halloween"] && !Shopify.designMode) return;
  try {
    
  const initialiseGcPotionAtmosphere = (root) => {
    const sections = [...root.querySelectorAll('[data-potion-atmosphere]')];
    if (sections.length === 0 || root.dataset.atmosphereReady === 'true') return;

    root.dataset.atmosphereReady = 'true';
    const defaultPrimary = getComputedStyle(root).getPropertyValue('--gc-red').trim() || '#a71920';
    const visibility = new Map(sections.map((section) => [section, 0]));
    const applyAtmosphere = (section) => {
      sections.forEach((item) => item.classList.toggle('is-atmosphere-active', item === section));
      if (!section) {
        root.style.setProperty('--gc-active-primary', defaultPrimary);
        root.style.setProperty('--gc-active-secondary', defaultPrimary);
        return;
      }
      root.style.setProperty('--gc-active-primary', section.dataset.potionPrimary || defaultPrimary);
      root.style.setProperty('--gc-active-secondary', section.dataset.potionSecondary || section.dataset.potionPrimary || defaultPrimary);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
      let activeSection = null;
      let highestVisibility = 0;
      visibility.forEach((ratio, section) => {
        if (ratio > highestVisibility) {
          highestVisibility = ratio;
          activeSection = section;
        }
      });
      applyAtmosphere(activeSection);
    }, {
      rootMargin: '-18% 0px -36% 0px',
      threshold: [0, .08, .18, .32, .5, .7]
    });

    sections.forEach((section) => observer.observe(section));
  };


  document.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-poison-menu"] && !Shopify.designMode) return;
  try {
    
  const initialiseGcPotionSelector = (root) => {
    const track = root.querySelector('[data-selector-track]');
    const cards = [...root.querySelectorAll('[data-selector-card]')];
    const previous = root.querySelector('[data-selector-prev]');
    const next = root.querySelector('[data-selector-next]');
    const dotsContainer = root.querySelector('[data-selector-dots]');
    if (!track || cards.length === 0 || root.dataset.selectorReady === 'true') return;

    root.dataset.selectorReady = 'true';
    const dots = cards.map(() => {
      const dot = document.createElement('span');
      dot.className = 'gc-potion-selector__dot';
      dotsContainer?.append(dot);
      return dot;
    });
    let activeIndex = 0;
    let frameRequested = false;
    let pointerStart = 0;
    let scrollStart = 0;
    let moved = false;

    const update = () => {
      const centre = track.scrollLeft + track.clientWidth / 2;
      let nearestDistance = Infinity;
      cards.forEach((card, index) => {
        const cardCentre = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCentre - centre);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });
      cards.forEach((card, index) => card.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
      frameRequested = false;
    };

    const requestUpdate = () => {
      if (!frameRequested) {
        frameRequested = true;
        requestAnimationFrame(update);
      }
    };

    const move = (direction) => {
      const targetIndex = Math.min(cards.length - 1, Math.max(0, activeIndex + direction));
      cards[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', requestUpdate, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    track.addEventListener('pointerdown', (event) => {
      pointerStart = event.clientX;
      scrollStart = track.scrollLeft;
      moved = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (!track.hasPointerCapture(event.pointerId)) return;
      const delta = event.clientX - pointerStart;
      if (Math.abs(delta) > 6) moved = true;
      track.scrollLeft = scrollStart - delta;
    });
    const finishDrag = (event) => {
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
      cards[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    cards.forEach((card) => card.addEventListener('click', (event) => {
      if (moved) event.preventDefault();
    }));
    update();
  };

  document.querySelectorAll('[data-potion-selector]').forEach(initialiseGcPotionSelector);
  const initialiseGcPotionAtmosphere = (root) => {
    const sections = [...root.querySelectorAll('[data-potion-atmosphere]')];
    if (sections.length === 0 || root.dataset.atmosphereReady === 'true') return;

    root.dataset.atmosphereReady = 'true';
    const defaultPrimary = getComputedStyle(root).getPropertyValue('--gc-red').trim() || '#a71920';
    const visibility = new Map(sections.map((section) => [section, 0]));
    const applyAtmosphere = (section) => {
      sections.forEach((item) => item.classList.toggle('is-atmosphere-active', item === section));
      if (!section) {
        root.style.setProperty('--gc-active-primary', defaultPrimary);
        root.style.setProperty('--gc-active-secondary', defaultPrimary);
        return;
      }
      root.style.setProperty('--gc-active-primary', section.dataset.potionPrimary || defaultPrimary);
      root.style.setProperty('--gc-active-secondary', section.dataset.potionSecondary || section.dataset.potionPrimary || defaultPrimary);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
      let activeSection = null;
      let highestVisibility = 0;
      visibility.forEach((ratio, section) => {
        if (ratio > highestVisibility) {
          highestVisibility = ratio;
          activeSection = section;
        }
      });
      applyAtmosphere(activeSection);
    }, {
      rootMargin: '-18% 0px -36% 0px',
      threshold: [0, .08, .18, .32, .5, .7]
    });

    sections.forEach((section) => observer.observe(section));
  };


  document.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greedy-campus-eu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const target = event.target.closest('[data-gc-event]');
    if (!target) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: target.dataset.gcEvent,
      gc_label: target.dataset.gcLabel || '',
      gc_url: target.getAttribute('href') || ''
    });
  });

  } catch(e) { console.error(e); }
})();
})();
